import { createAsyncThunk } from '@reduxjs/toolkit'
import Flag from './flag-model'
import { delete_flag, load_flags, store_flag } from './flag-service'

export const LoadFlagsAsync = createAsyncThunk<any, any>(
  'composer/load/flag',
  async (params: { uid: string }) => {
    return await load_flags(params)
  },
)

export const CreateFlagAsync = createAsyncThunk<any, any>(
  'composer/create/flag',
  async (params: Flag) => {
    return await store_flag(params)
  },
)

export const DeleteFlagAsync = createAsyncThunk<any, any>(
  'composer/delete/flag',
  async (params) => {
    return await delete_flag(params)
  },
)
